import PubSub from "pubsub-js";
import gsap from 'gsap';

var ListingFaq = function(options) {

	this.options = {
		$el: false,
		baseClass: 'comp-ListingFaq',
	};

	$.extend(true, this.options, options);

};

ListingFaq.prototype.init = function() {

	var self = this;

	this.$faqItemRows = this.options.$el.find(`.${self.options.baseClass}__faqItemRow`);
	this.openRow = null;

	this.$faqItemRows.on('click', function() {

		if ($(this).is(self.openRow)) {
			self.closeDropdown($(this));
		}
		else {
			self.openDropdown($(this));
		}

	});

};

ListingFaq.prototype.openDropdown = function($faqRow) {

	var self = this;

	var $faqItem = $faqRow.find(`.${self.options.baseClass}__faqItem`);
	var $rowAnswerWrapper = $faqRow.find(`.${self.options.baseClass}__faqItem__answerWrapper`);
	var $rowArrow = $faqRow.find(`.${self.options.baseClass}__faqItem__question__arrow`);

	self.closeDropdown(this.openRow); // close the open row, max 1 open at a time

	this.openRow = $faqRow;
	$faqItem.addClass(`${self.options.baseClass}__faqItem--active`);

	gsap.timeline(
		{
			defaults: {
				ease: "power1.out",
				duration: 0.45
			}
		}
	)
	.to($rowAnswerWrapper,
		{
			height: "auto"
		}
	)
	.to($rowArrow,
		{
			rotate: 180
		},
		"<"
	)
	;

};

ListingFaq.prototype.closeDropdown = function($faqRow) {

	var self = this;

	if (!$faqRow) { return; }

	var $faqItem = $faqRow.find(`.${self.options.baseClass}__faqItem`);
	var $rowAnswerWrapper = $faqRow.find(`.${self.options.baseClass}__faqItem__answerWrapper`);
	var $rowArrow = $faqRow.find(`.${self.options.baseClass}__faqItem__question__arrow`);

	self.openRow = null;
	$faqItem.removeClass(`${self.options.baseClass}__faqItem--active`);

	gsap.timeline(
		{
			defaults: {
				ease: "power1.out",
				duration: 0.45
			}
		}
	)
	.to($rowAnswerWrapper,
		{
			height: 0
		}
	)
	.to($rowArrow,
		{
			rotate: 0
		},
		"<"
	)
	;

};

export default ListingFaq;
